module.exports = __webpack_public_path__ + "img/3.be05cb09.jpg";